import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrPF: CultureInfo = {
  name: 'fr-PF',
  displayName: 'français (Polynésie française)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-PF',
  parent: CultureInfoFr
};
